// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__WCyUY","imageUploader":"EGiftCard_imageUploader__3G7Pd"};